<template>
  <span>
  <Portlet
      :full-height="true"
      :no-padding="true"
      :headSeparator="true"
      :hasFooter="true"  >

      <template slot="Title" >
        Track comparison results
      </template>

      <template slot="Options">
        <template >
          <span></span>
            <UploadMultiSearchButton />
           <span v-tooltip="{ data:  'Download template' , arrowPosition: 'right'}" style="margin-left: 7px">
              <Button @click="download"  download>
                <template>{{  'Download template' }}</template>
              </Button>
            </span>

        </template>
      </template><br>

      <template slot="Search">

      </template>

      <template slot="PortletNav">

      </template>
    <template slot="Content" >
      <div class="padding_table">
        <DataTable :value="items" :size="'Large'" tableStyle="min-width: 50rem">
          <Column  header="Name" style="width: 25%">
            <template #body="slotProps">
               <router-link
                   style="color:#2b2b2b"
                   :to="{name:'multiSearchDetail', params:{id:slotProps.data.uid ,stationUid:currentStationUid}}"
                   v-text="'Upload from  '+moment(slotProps.data.created).format('Do MMM YYYY')">

               </router-link>
            </template>
          </Column>
          <Column  header="Station" style="width: 25%">
            <template #body="slotProps">
               <router-link
                   style="color:#2b2b2b" :to="{name:'Dashboard', params:{stationUid:currentStationUid}}"
                   v-text="filteredStations(slotProps.data.stationUid)[0].name">
               </router-link>
            </template>
          </Column>
          <Column field="status" header="Status" style="width: 10%">
            <template #body="slotProps">
                    <Tag  v-if="slotProps.data.status === 2" :value="'SEARCHING'" :severity="'warning'" style="background: #f97316; color:#ffffff"/>
                    <Tag  v-if="slotProps.data.status === 4" :value="'COMPLETED'" :severity="'success'" />
                    <Tag  v-if="slotProps.data.status=== 5" :value="'ERROR'" :severity="'Danger'" style="background: red" />
                    <Tag  v-if="slotProps.data.status=== 1" :value="'INIT'" :severity="'Secondary'" />
                    <Tag  v-if="slotProps.data.status=== 3" :value="'SAVING'" :severity="'Info'" />
            </template>
          </Column>
          <Column field="total" header="Total" style="width: 7%"></Column>
          <Column field="found" header="Found" style="width: 7%"></Column>
          <Column field="new" header="Missing" style="width: 7%">
             <template #body="slotProps">
               <span v-text="slotProps.data.total - slotProps.data.found">    </span>
            </template>
          </Column>
          <Column  header="Date" style="width: 20%">
               <template #body="slotProps">
               <span v-text="moment(slotProps.data.created)">    </span>
            </template>
          </Column>
      </DataTable>
      </div>


    </template>

    <template slot="">

    </template>

  </Portlet>
</span>
</template>

<script>
import Portlet from "@/components/common/Portlet";
import router from "@/router";
import store from "@/store";
import {HTTP} from "@/utils/http";
import moment from "moment";
import DuplicateItems from "@/components/Library/DuplicateItems.vue";
import UploadButton from "@/components/Library/UploadButton.vue";
import MenuSection from "@/components/Library/__MenuSection.vue";
import UploadMultiSearchButton from "@/components/Library/UploadMultiSearchButton.vue";
import Axios from "axios";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tag from 'primevue/tag';
import Constants from "@/store/constants";
import {mapState} from "vuex";
export default {
  name: "MasterMultiSearchListSection",
  router,
  store,
  components: {
    MenuSection, UploadButton, DuplicateItems, UploadMultiSearchButton,DataTable,
    Portlet,Column,Tag
  },
  created() {},
  beforeDestroy(){},
  data() {
    return {
      uploadData: null,
      errorMessage: false,
      items: [],
      moment,
    }
  },
  computed: {
    Constants: () => Constants,
    ...mapState({
      currentStationUid: function () {
        return store.state.currentStationUid;
      }
    }),
  },
  mounted() {
    this.loadData();
    setInterval(this.loadData, 30000);
  },
  methods: {
    filteredStations (uid) {
      console.log(uid)
      if(uid ==='00000000-0000-0000-0000-000000000000'){
        return [{name:'Station undefined'}]
      }

      // console.log(this.$store.state.stations.items , uid)
      if (this.$store.state.stations.items.length > 0) {
        return (this.$store.state.stations.items || []).filter(station => {
          console.log(station.uid === uid)
          return station.uid === uid;
        })
      }

    },
    download () {
      const url = '/Template.csv';
      // window.location.href = url;
      Axios.get(url, { responseType: 'blob' })
          .then(response => {
            const blob = new Blob([response.data], { type: 'text/csv' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'Template'
            link.click()
            URL.revokeObjectURL(link.href)
          }).catch(console.error)
    },
    loadData(){
      HTTP.get('api/multi-search/list?date='+this.$route.params.since)
          .then(({ data }) => {


            this.errorMessage = false;
            this.uploadData = data.dataItem
            this.items = this.uploadData.items;
            console.log('----------++++++++++++++++++++++++++++---' , this.items)
          })
          .catch(error => {

            this.errorMessage = true;
            console.log('-------------')
            console.log('error', error)
          })

    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.back-button {
  margin-right: 20px;
  align-self: center;

  i {
    padding: 0;
    font-size: 14px;
  }
}
td:last-child{
  background: inherit;
}
.title-text {
  align-self: center;
}

// Search
.portlet-search {
  display: flex;
  align-items: center;
justify-content: flex-end;
  .fa-search {
    margin-right: 20px;
    color: var(--COLOR_BRAND);
  }

  .portlet-search-advanced {
    border: 0;
    background-color: transparent;
    margin-left: 20px;
    font-size: 11px;
    font-weight: 600;
    padding: 9px 15px;
    letter-spacing: 0.7px;
    text-transform: uppercase;

    &:hover {
      text-decoration: none;
    }
  }

  .portlet-search-input {
    flex-grow: 1;
    font-size: 14px;
    letter-spacing: 0.2px;
    line-height: 17px;
    color: var(--COLOR_TEXT);
    border-bottom: 1px solid var(--COLOR_BRAND);

    &[value=""] {
      border-bottom: 1px solid var(--COLOR_LIGHT);
    }
    &:focus {
      border-bottom: 1px solid var(--COLOR_BRAND);
    }
  }

  .portlet-search-submit {
    margin-left: 5px;
    text-transform: uppercase;
  }

  .portlet-search-close {

    i {
      transition: color 0.2s ease-in-out;
      font-size: 20px;
    }

    &:not(:hover) {
      i {
        color: #d2d2d2;
      }
    }
  }
}
.padding_table{
  padding:25px;
}
</style>
